var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_899_2648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3536 6.35355C13.4357 6.256 13.4837 6.13155 13.4817 6.00245C13.4797 5.87339 13.4287 5.751 13.3389 5.66113C13.249 5.57126 13.1266 5.52028 12.9976 5.51832C12.8684 5.51631 12.744 5.56425 12.6464 5.64645C12.4656 5.79897 12.2855 5.9522 12.1061 6.10614C10.4916 7.49159 8.93431 8.93432 7.43432 10.4343L8.56569 10.4343C7.06569 8.93431 5.50841 7.49159 3.89386 6.10614C3.71446 5.9522 3.53436 5.79897 3.35355 5.64645C3.256 5.56425 3.13155 5.51631 3.00245 5.51832C2.87339 5.52028 2.751 5.57126 2.66113 5.66113C2.57126 5.751 2.52028 5.87339 2.51832 6.00245C2.51631 6.13155 2.56425 6.256 2.64645 6.35355C2.79897 6.53436 2.9522 6.71446 3.10614 6.89386C4.49159 8.50841 5.93431 10.0657 7.43432 11.5657C7.75431 11.8857 8.24569 11.8857 8.56569 11.5657C10.0657 10.0657 11.5084 8.50841 12.8939 6.89386C13.0478 6.71446 13.201 6.53436 13.3536 6.35355Z",
    fill: "#2B2B2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_899_2648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqDown);
export default __webpack_public_path__ + "static/media/faq_down.9348706369bc475ac759618c37de4806.svg";
export { ForwardRef as ReactComponent };